export var DroneType;
(function (DroneType) {
    DroneType["Pixel"] = "Pixel";
    DroneType["Visliuk"] = "Visliuk";
    DroneType["Poni"] = "Poni";
    DroneType["Pony"] = "Pony";
})(DroneType || (DroneType = {}));
